export enum AiAnalysisTypes {
    EXECUTIVE_SUMMARY = 'EXECUTIVE_SUMMARY',
    CUSTOM = 'CUSTOM',
    KEY_TAKEAWAYS = 'KEY_TAKEAWAYS',
    BRAND_IMPACT = 'BRAND_IMPACT',
    SENTIMENT_OPINION = 'SENTIMENT_OPINION',
    TOP_NARRATIVES = 'TOP_NARRATIVES',

    // Collection key narratives
    COLLECTION_KEY_MESSAGES_DEFAULT = 'COLLECTION_KEY_MESSAGES_DEFAULT',
    COLLECTION_KEY_MESSAGES_USER_DEFINED = 'COLLECTION_KEY_MESSAGES_USER_DEFINED',
    COLLECTION_TOP_MENTIONS  = 'COLLECTION_TOP_MENTIONS',
    COLLECTION_CUSTOM = 'COLLECTION_CUSTOM',

    // Coverage insight
    COVERAGE_INSIGHT_EXTENDED_ANALYSIS = 'COVERAGE_INSIGHT_EXTENDED_ANALYSIS',
    COVERAGE_INSIGHT_CONTEXTUAL_ANALYSIS = 'COVERAGE_INSIGHT_CONTEXTUAL_ANALYSIS',
    COVERAGE_INSIGHT_SENTIMENT_OPINION = 'COVERAGE_INSIGHT_SENTIMENT_OPINION',
    COVERAGE_INSIGHT_SENTIMENT_OPINION_WITH_KEYWORDS = 'COVERAGE_INSIGHT_SENTIMENT_OPINION_WITH_KEYWORDS',
    COVERAGE_INSIGHT_BRAND_IMPACT = 'COVERAGE_INSIGHT_BRAND_IMPACT',
    COVERAGE_INSIGHT_RESEARCH_AND_BACKGROUND_LINKS = 'COVERAGE_INSIGHT_RESEARCH_AND_BACKGROUND_LINKS',

    COVERAGE_SURGE_INSIGHT = 'COVERAGE_SURGE_INSIGHT',

    // Action assistant
    COVERAGE_ACTION_ASSISTANT = 'COVERAGE_ACTION_ASSISTANT',
    POSITION_SUGGESTION = 'POSITION_SUGGESTION'
}
